import React, { Component, Fragment } from 'react';

import styles from './MainPageProject.css'
import fonts from '../../../styles/fonts.css'

class MainPageProject extends Component {
    render() {
        var direction = this.props.project.direction;

        // Restore the original trapeznikov.com layouts:
        //   rtl (alexa)   -> big image left, narrow text right
        //   ltr (trucker) -> narrow text left, big image right
        //   top (photolab)-> full-width text, full-width image below
        var bodyClass = styles["project-body"];
        if (direction === "rtl") {
            bodyClass = [styles["project-body"], styles["dir-media-left"]].join(' ');
        } else if (direction === "ltr") {
            bodyClass = [styles["project-body"], styles["dir-media-right"]].join(' ');
        } else if (direction === "top") {
            bodyClass = [styles["project-body"], styles["dir-top"]].join(' ');
        }

        var hasMobileVariant = this.props.project.mobileImage !== '';

        var mobileImage = null;
        var desktopImageClass = styles['photo-image'];
        if (hasMobileVariant) {
            mobileImage = (
                <img className={[styles['photo-image'], styles['mobile-only']].join(' ')}
                     src={this.props.project.mobileImage} alt={this.props.project.title} />
            );
            desktopImageClass = [styles['photo-image'], styles['desktop-only']].join(' ');
        }

        var badge = null;
        if (this.props.project.badge) {
            badge = <span className={styles["title-badge"]}>{this.props.project.badge}</span>;
        }

        var desktopDescriptionClass = hasMobileVariant ? styles["desktop-only"] : "";
        var mobileDescription = null;
        if (this.props.project.mobileDescription !== '') {
            mobileDescription = (
                <div className={[styles.paragraph, styles["mobile-only"]].join(' ')}
                     dangerouslySetInnerHTML={{ __html: this.props.project.mobileDescription }} />
            );
        }

        return (
            <Fragment>
                <div className={styles.project}>
                    <div className={[fonts["title-bold"], styles["project-title"]].join(' ')}>
                        <span className={styles.prompt}>&gt;</span>
                        <span>{this.props.project.title.toLowerCase()}</span>
                        {badge}
                    </div>
                    <div className={bodyClass}>
                        <div className={styles["project-text"]}>
                            <div className={[styles.paragraph, desktopDescriptionClass].join(' ')}
                                 dangerouslySetInnerHTML={{ __html: this.props.project.description }} />
                            {mobileDescription}
                            <div className={styles['appstores']}>
                                <a className={[fonts["title"], styles['appstore']].join(' ')}
                                   href={this.props.project.googlePlayUrl} target="_blank" rel="noopener noreferrer">
                                    <svg className={styles["appstore-icon"]} aria-hidden="true" role="img"
                                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="currentColor" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"></path>
                                    </svg>
                                    google play
                                </a>
                                <a className={[fonts["title"], styles['appstore']].join(' ')}
                                   href={this.props.project.appStoreUrl} target="_blank" rel="noopener noreferrer">
                                    <svg className={styles["appstore-icon"]} aria-hidden="true" role="img"
                                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"></path>
                                    </svg>
                                    app store
                                </a>
                            </div>
                        </div>
                        <div className={styles["project-media"]}>
                            <img className={desktopImageClass} src={this.props.project.image} alt={this.props.project.title} />
                            {mobileImage}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MainPageProject;
